export var TESTING_PARAM_NAME = 'sc_device';
export var TESTING_PARAM_VALUE = 'beautyapp';
export var isTestingParam = function isTestingParam() {
  var siteUrl = new URL(window.location.href);
  return siteUrl.searchParams.get(TESTING_PARAM_NAME) === TESTING_PARAM_VALUE;
};
export var USER_AGENT_FLAG = 'BeautyAppV3';
export var isUserAgentFlag = function isUserAgentFlag() {
  return navigator.userAgent.includes(USER_AGENT_FLAG);
};
export var isBeautyApp = function isBeautyApp() {
  if (typeof window === 'undefined') return false;
  return isTestingParam() || isUserAgentFlag();
};